













import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatRoundedButton',
  props: {
    disabled: { type: Boolean as PropType<boolean>, default: false },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
});
